import { flexRender, Table as TableType } from "@tanstack/react-table";

import { ScrollArea } from "@/components//ui/scroll-area";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow
} from "@/components/ui/table";

interface DashboardTableProps<TData> {
  readonly table: TableType<TData>;
  readonly emptyDataMessage?: string | React.ReactNode;
}

export const DashboardTable = <TData,>({
  table,
  emptyDataMessage = "No results."
}: Readonly<DashboardTableProps<TData>>) => (
  <ScrollArea className="border border-[#E5E7EB] rounded-md mb-2">
    <Table className="rounded-md relative table-fixed">
      <TableHeader>
        {table.getHeaderGroups().map((headerGroup) => (
          <TableRow key={headerGroup.id}>
            {headerGroup.headers.map((header) => (
              <TableHead
                key={header.id}
                className="bg-white-smoke py-2 px-3"
                style={{
                  width:
                    // using the maxSize logic from react-table
                    header.column.columnDef.maxSize !== Number.MAX_SAFE_INTEGER
                      ? `${header.getSize()}px`
                      : undefined
                }}
              >
                {flexRender(
                  header.column.columnDef.header,
                  header.getContext()
                )}
              </TableHead>
            ))}
          </TableRow>
        ))}
      </TableHeader>
      <TableBody>
        {table.getRowModel().rows?.length ? (
          table.getRowModel().rows.map((row) => (
            <TableRow
              key={row.id}
              data-state={row.getIsSelected() && "selected"}
            >
              {row.getVisibleCells().map((cell) => (
                <TableCell key={cell.id} className="py-2 px-3">
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </TableCell>
              ))}
            </TableRow>
          ))
        ) : (
          <TableRow>
            <TableCell
              colSpan={table.getAllColumns().length}
              className="h-24 text-center"
            >
              {emptyDataMessage}
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  </ScrollArea>
);

export default DashboardTable;
